import { QuestionCircleOutlined } from '@ant-design/icons';
import { useSuppressionListsCRUDActions } from '@mm/state/actions/SuppressionListsCRUDActions';
import { selectKlaviyoSuppressionList } from '@mm/state/modules/suppressionListsTableState/selectors';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { Switch } from 'antd';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { HelpCenter } from '../../../../../../../../common/components/HelpCenter/HelpCenter';
import styles from './KlaviyoIntegrations.module.css';

type Props = {
  controlsDisabled: boolean;
  tokenType: 'api_key' | 'oauth_token';
  tokenId: number;
  activeFbPageId: number;
  helpLink?: string;
  withNavLink?: boolean;
};

export const KlaviyoSuppressionSetup = ({
  controlsDisabled,
  tokenType,
  tokenId,
  activeFbPageId,
  helpLink,
  withNavLink = true,
}: Props) => {
  const { update, create, retrieveAll } = useSuppressionListsCRUDActions();
  const suppressions = useSelector(selectKlaviyoSuppressionList);
  const featureFlags = useSelector(combinedFeatureFlagsSelector);
  const suppression = suppressions[0];
  const sendSignal = suppression?.data ? suppression.data?.sendSignal : true;

  const updateSuppression = (enabled: boolean, sendSignal: boolean) => {
    const tokenKey =
      tokenType === 'api_key' ? 'klaviyo_api_key' : 'klaviyo_oauth';
    if (suppression?.id) {
      update(activeFbPageId, {
        id: suppression.id,
        enabled,
        data: { sendSignal },
        sourceId: suppression.sourceId,
        sourceKind: tokenKey,
      });
    } else {
      create(activeFbPageId, {
        enabled,
        data: { sendSignal },
        sourceId: tokenId,
        sourceKind: tokenKey,
      });
    }
  };

  useEffect(() => {
    if (suppressions.length === 0) {
      retrieveAll(activeFbPageId);
    }
  }, []);

  return (
    <div
      className={classNames(styles.box, styles.suppressionBox, {
        [styles.boxDisabled]: controlsDisabled,
        [styles.whiteBox]: featureFlags.compliant_klaviyo_app,
      })}
    >
      <div className={classNames(styles.boxWithHelp)}>
        <div className={styles.boxContent}>
          <div className={classNames(styles.heading, styles.headingWithSwitch)}>
            Automatically suppress Klaviyo contacts
            <Switch
              key={`switch-suppression-${
                suppression?.enabled ? 'enabled' : 'disabled'
              }`}
              defaultChecked={!!suppression?.enabled}
              checkedChildren="Yes"
              unCheckedChildren="No"
              className={styles.switch}
              onChange={ok => updateSuppression(ok, !!sendSignal)}
            />
          </div>
        </div>
        {helpLink === undefined ? null : (
          <HelpCenter helpLink={helpLink} className={styles.help} />
        )}
      </div>
    </div>
  );
};
